/**
 * Functions for file related API calls and components
 * See also fileinfo.service.js
 */

/**
 * The (new 2025) FileInfo object from the backend. See FileInfo.java
 */
export class FileInfo {
	/** @type {!number} */
	id;
	/** @type {!string} */
	documentId;
	/** @type {!string} */
	filename;
	/** @type {!string} */
	fileType;
	/** @type {!string} */
	title;
	/** @type {string[]} */
	folders;
}

/**
 * 
 * @param {string?} fileName 
 * @returns "" or "URL" or e.g. "PDF"
 */
function guessFileType(fileName) {
	if (!fileName) return "";
	if (fileName.includes("://")) {
		return "URL";
	}
	// pop the last .X
	const type = fileName.slice(fileName.lastIndexOf(".") + 1);
	return type.toUpperCase();
}

/**
 * @param {FileInfo} fileInfo 
 * @returns e.g. "pdf"
 */
export function getFileType(fileInfo) {
	return fileInfo.fileType || guessFileType(fileInfo.filename);
}

/**
 * Convert file-size into a human-readable string e.g. "1.2mb"
 * @param {number} size in bytes	
 * @returns {string} e.g. "1.2mb"
 */
export function sizeToString(size) {
	if (size==null || size === undefined) return "";
	if (size < 1024 * 1024) {
		return (size / 1024).toFixed(1) + "kb";
	}
	if (size < 1024 * 1024 * 1024) {
		return (size / 1024 / 1024).toFixed(1) + "mb";
	}
	return (size / 1024 / 1024 / 1024).toFixed(1) + "gb";
}

/**
 * Get the folder id for a given questionnaire round id.
 * 
 * Uses "Round" as the type marker (instead of "IssbQuestionnaire") for readability and future-proofing.
 * 
 * (This keeps the "type:id" hack in one place)
 * 
 * @param {string?} qRoundId 
 * @returns {string?}
 */
export function getFolderForRound(qRoundId) {
	return qRoundId ? "Round:"+qRoundId : null;
}

/**
 * The folder id for the ESG360 Knowledge Base
 */
export const KB_FOLDER = "KB";
